//import moment from 'moment'
import moment from 'moment-timezone'

moment.tz.setDefault('Etc/GMT+4')

export default {
  moment(date, format) {
    if (format === '') {
      format = 'M/d/YYYY'
    }
    return moment(date).format(format);
  },
  capitalize(value) {
    if (!value) return ''
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
  },
  decimal(value, precision) {
    return isNaN(value) ? 0 : parseFloat(value).toFixed(precision)
  },
  inBetween(value, start, end) {
    const amount = parseFloat(value)
    const amountStart = parseFloat(start)
    const amountEnd = parseFloat(end)

    return amount.valueOf() >= amountStart.valueOf() && value.valueOf() <= amountEnd.valueOf()
  }
}

